import React from 'react';

export const CreditCardFeather = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
	<svg fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" {...props}>
		<rect width="22" height="16" x="1" y="4" rx="2" ry="2" />
		<path d="M1 10L23 10" />
	</svg>
);
